import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { eventCategoryService } from "../api/eventCategoryService";

const fetchConfig = laravelServiceSelectFetchConfig(eventCategoryService);
interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const EventCategoryMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
